import { useController } from "react-hook-form";
import FormField, { useFormField } from "./FormField/FormField";
import { UseFormFieldProps } from "./Form.types";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";

export interface FormDatePickerProps
  extends UseFormFieldProps, Omit<DatePickerProps<Date>, "label"> {}

export function FormDatePicker(props: FormDatePickerProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <DatePicker {...field} {...childProps} value={field.value ?? null} />
    </FormField>
  );
}
